<template>
    <ViewBonRetour/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ViewBonRetour from "@/components/GesCom/BonRetour/ViewBonRetour.vue";

    export default defineComponent({
      name: "ViewBonRetourPage",
      components: {
        ViewBonRetour,
      },
    });
  </script>